import styled from 'styled-components';
import {palette} from 'styled-theme';
import WithDirection from '../../settings/withDirection';

const KarieLogoStyleWrapper = styled.div`

.isoLogoWrapper {
    width: 100%;
    display: flex;
    margin-bottom: 70px;
    text-align: -webkit-center;

    a {
      font-size: 24px;
      font-weight: 300;
      line-height: 1;
      text-transform: uppercase;
      color: ${palette('secondary', 2)};
    }

    img {
      width: 50%;
    }

    span {
      vertical-align: bottom;
    }
  }

`;

export default WithDirection(KarieLogoStyleWrapper);
